// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"UtilizatonByTeamChart_scrollbar__Pct73"};